import React from 'react';
import { useIntl } from 'react-intl';
import { GameOptions } from '../../config';
import { getLeaderboardGameOptions } from '../../utils/getLeaderboardGameOptions';
import Filter from '../Filter';
export default function GameTypeFilters(_a) {
    var handleChange = _a.handleChange, renderAdditionalFilters = _a.renderAdditionalFilters, leaderboard = _a.leaderboard, currentGameType = _a.currentGameType;
    var intl = useIntl();
    var shouldBeVisible = function (g) {
        var gameType = leaderboard === null || leaderboard === void 0 ? void 0 : leaderboard[g];
        return gameType !== undefined && (gameType === null || gameType === void 0 ? void 0 : gameType.players.length) > 0;
    };
    var getFilteredGameOptions = function () {
        return getLeaderboardGameOptions().filter(function (g) { return shouldBeVisible(g); });
    };
    var getLabel = function (g) {
        var gameType = leaderboard === null || leaderboard === void 0 ? void 0 : leaderboard[g];
        if (!gameType) {
            return g;
        }
        return intl.formatMessage({ id: "gameFormats.type".concat(gameType.id) });
    };
    var getDefaultOptions = function () {
        return getFilteredGameOptions().map(function (option) {
            var scratch = intl.formatMessage({ id: 'leaderboard.scratch' });
            var label = option === GameOptions.SCRATCH ? scratch : getLabel(option);
            return { label: label, value: option };
        });
    };
    return (React.createElement("div", { className: "game-type-filters" },
        getFilteredGameOptions().length > 0 && (React.createElement(Filter, { options: getDefaultOptions(), handleChange: function (e) { return handleChange(e); }, currentValue: currentGameType })),
        renderAdditionalFilters && renderAdditionalFilters()));
}
